import * as S from './InfoModal.styled';
import { ModalButton as Button } from '../ModalButton';
import { ModalTypes, IInfoModalProps } from './IInfoModal';
import { IconMenu } from '@core-web/ui';
import { IconMenuType } from '@core-web/ui/HeaderIconMenu/HeaderIconMenu';
import { IconNames } from '@core-web/ui/Icon';

export const InfoModal = (props: IInfoModalProps): JSX.Element => {
  const {
    icon,
    title,
    subTitle,
    customStyle,
    confirmButtonText,
    cancelButtonText,
    onConfirm,
    onClose,
    modalType,
    isLoading,
    onCrossBtnClick,
    showModalHeader,
    modalTitle = 'Title needed',
    iconColor,
  } = props;
  const confirmButtonType = modalType === ModalTypes.Success || modalType === ModalTypes.Danger ? modalType : 'primary';

  return (
    <S.InfoModalWrapper>
      {showModalHeader && (
        <S.ModalHeader>
          <S.HeaderTitle>{modalTitle}</S.HeaderTitle>
        </S.ModalHeader>
      )}
      {onCrossBtnClick && (
        <S.CloseBtnWrapper>
          <IconMenu type={IconMenuType.NORMAL} menuIcon={IconNames.CROSS_14} onClick={onCrossBtnClick} />
        </S.CloseBtnWrapper>
      )}
      <S.ModalBody>
        <S.InfoModalIconWrapper className={modalType ? modalType : ''} iconColor={iconColor}>
          {icon}
        </S.InfoModalIconWrapper>
        {!isLoading && <S.InfoModalTitle customStyle={customStyle}>{title}</S.InfoModalTitle>}
        {!isLoading && <S.InfoModalTitle>{subTitle}</S.InfoModalTitle>}
      </S.ModalBody>
      {!isLoading && (
        <S.ModalFooter>
          <Button title={confirmButtonText} onClick={onConfirm} variant={confirmButtonType} />
          <Button title={cancelButtonText} onClick={onClose} variant='outline-light' />
        </S.ModalFooter>
      )}
    </S.InfoModalWrapper>
  );
};
